(() => {
  const sizeChartClass = 'custom-size-chart-clear-v1';
  const mediaClass = 'custom-more-colors-media-before-size-chart-v1';
  const imageClass = 'custom-more-colors-image-before-size-chart-v1';

  const compactText = (value) => String(value || '').replace(/\s+/g, '').toUpperCase();
  const isSizeChart = (details) => {
    const summary = details.querySelector(':scope > summary');
    return summary && compactText(summary.textContent).includes('SIZECHART');
  };

  const markProtectedBoundary = (details) => {
    if (!isSizeChart(details) || details.classList.contains(sizeChartClass)) return;

    const preceding = [];
    let sibling = details.previousElementSibling;
    let foundMoreColors = false;

    while (sibling && preceding.length < 16) {
      preceding.push(sibling);
      const text = compactText(sibling.textContent);
      if (text.includes('MORECOLORSAVAILABLE') || text.includes('MORECOLOURSAVAILABLE')) {
        foundMoreColors = true;
        break;
      }
      sibling = sibling.previousElementSibling;
    }

    if (!foundMoreColors) return;

    details.classList.add(sizeChartClass);
    preceding.forEach((element) => {
      const images = element.matches('img') ? [element] : [...element.querySelectorAll('img')];
      if (!images.length) return;
      element.classList.add(mediaClass);
      images.forEach((image) => image.classList.add(imageClass));
    });
  };

  const initialize = (root = document) => {
    root.querySelectorAll('.product__description details').forEach(markProtectedBoundary);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
